import './styles';
import {Box, Typography} from '@mui/material';

import ResultScreen from '@/app/shared-components/ResultScreen/ResultScreen';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

const AccountCreatedResultContent = () => {
  const {handleDurationEnds} = useViewModelProvider();

  return (
    <ResultScreen
      imgSrc="/assets/images/etc/celebration.webp"
      title={
        <Box className="content">
          <Typography className="title your">Your</Typography>
          <Typography className="title">account's been created!</Typography>
          <Typography className="title">Let's get</Typography>
          <Typography className="title your-kid">your kid</Typography>
          <Typography className="title">set up</Typography>
        </Box>
      }
      progressBarDuration={3200}
      onDurationEnds={handleDurationEnds}
      showConfetti
    />
  );
};

const AccountCreatedResultPage = () => (
  <ViewModelProvider>
    <AccountCreatedResultContent />
  </ViewModelProvider>
);

export default AccountCreatedResultPage;
